import { useEffect } from 'react';
import { useAlertStore } from '@/stores/alertStore';
import { useAssetStore } from '@/stores/assetStore';
import { isTauri } from '@/utils/tauri';
import { useLifecycleTracker } from '@/utils/memoryLeak';

export const usePriceAlerts = () => {
  const { alerts, checkAlerts, markTriggered } = useAlertStore();
  const { assets } = useAssetStore();
  const lifecycleTracker = useLifecycleTracker();

  useEffect(() => {
    if (!isTauri()) {
      // 浏览器环境，跳过通知功能
      return;
    }

    const checkAllAlerts = async () => {
      for (const asset of assets) {
        if (asset.price !== undefined) {
          const triggeredAlerts = checkAlerts(asset.id, asset.price);
          
          for (const alert of triggeredAlerts) {
            try {
              const { sendNotification } = await import('@tauri-apps/plugin-notification');
              await sendNotification({
                title: '价格提醒',
                body: `${alert.assetSymbol} 价格已${alert.direction === 'above' ? '超过' : '低于'} ${alert.threshold}`,
              });
              markTriggered(alert.id);
            } catch (error) {
              console.error('发送通知失败:', error);
            }
          }
        }
      }
    };

    // 每5秒检查一次提醒
    const interval = lifecycleTracker.setInterval(checkAllAlerts, 5000);
    
    return () => {
      lifecycleTracker.clearInterval(interval);
    };
  }, [assets, alerts, checkAlerts, markTriggered, lifecycleTracker]);
};
